import React from "react";

interface ProductInfoBlockProps {
  title?: string;
  description?: string;
}

const ProductInfoBlock: React.FC<ProductInfoBlockProps> = ({ title, description }) => (
  <div className="brick">
    <h3 className="product-info__block-heading">{title}</h3>
    <div
      className="product-info__block-description"
      dangerouslySetInnerHTML={{ __html: description ?? "" }}
    />
  </div>
);

export default ProductInfoBlock;
